import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  productContainer: {
    width: '100%',
    marginLeft: 8
  },

  productItem: {
    width: 300
  },

  selectItem: {
    width: 255
  },

  detailItems: {
    width: 90
  },

  addButton: {
    '.ant-btn': {
      padding: 0
    }
  },

  drawerIcon: {
    cursor: 'pointer',
    marginTop: 8
  }
}))
